<template>
  <div class="ac-card-content">
    <div class="ac-header-container justify-start">
      <button type="button" class="ac-close-button" @click="() => toggleActionModal(false)">
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
      <div class="ac-header ml-2">Invitation to join membership</div>
    </div>
    <div class="ac-body-container">
      <div class="margin-bottom-12">
        Send a quick text invite to guide individuals 
        toward starting their membership, helping drive higher plan sign-up rates.
      </div>
      <div class="banner">
        <div class="phone-container">
          <div 
            class="background-container"
            :style="{ backgroundColor: partnerSettings?.PRIMARY_COLOR || '#0045FF' }"
          >
            <img :src="partnerSettings?.LOGO_URL || '@shared/assets/img/logo/white-logo.png'" alt="logo" class="logo" />
          </div>
          <img
            src="@shared/assets/img/customer/home.png"
            alt="phone"
            class="phone"
          />
        </div>
      </div>
      <div class="flex-row">
        <button
          type="button"
          class="flex-column align-center just-center box"
          @click="() => toggleActionModal(true, 'invite-manual-member')"
        >
          <span class="icon-luc-Plus sac__font-40 margin-bottom-8 n110" />
          <span class="sac__font-14 n110">Individual</span>
        </button>
        <button
          type="button"
          class="flex-column align-center just-center box"
          @click="goToCampaigns"
        >
          <span
            class="icon-luc-FileSpreadsheet sac__font-40 margin-bottom-8 n110"
          />
          <span class="sac__font-14 n110">Multiple</span>
          <span class="sac__font-14 n110">(creates campaign)</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'ChooseMethod',
  props: {
    toggleActionModal: Function,
  },
  computed: {
    ...mapState({
      partnerSettings: (state) => state.customer.selectedPartnerSettings,
    }),
  },
  methods: {
    goToCampaigns() {
      window.location.href = '/campaigns/easy-enroll';
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  cursor: pointer;
  width: 100%;
  height: 200px;
  border: 2px solid #cccccc;
  border-radius: 6.5px;
  &:first-child {
    margin-right: 20px;
  }
}

.banner {
  background-image: url("@shared/assets/img/customer/connect-banner.png");
  background-size: cover;
  height: 130px;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 34px;
  .phone-container {
    position: relative;
    .background-container {
      position: absolute;
      right: 4px;
      left: 4px;
      bottom: 12px;
      top: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      border-top-right-radius: 28px;
      border-top-left-radius: 28px;
      .logo {
        width: 80%;
      }
    }
    .phone {
      position: relative;
      width: 120px;
      z-index: 5;
    }
  }
}
</style>
